<template>
  <div
    class="setting_main_contents"
    id="dispatch-job-main-content"
    v-on:scroll="scrollMenuItem"
  >
    <div :class="{'overlay_setting':isLoadingData}">
      <i :class="{'loadding_setting': isLoadingData}"></i>
    </div>
    <div class="setting_heading">
      <h1 class="setting_heading_title">
        {{ dispatchJobSettingProperty.TAB_HEADER }}
      </h1>
      <p class="setting_heading_explain">
        {{ dispatchJobSettingProperty.SUB_HEADER }}
      </p>
    </div>
    <div class="setting_tab">
      <div class="setting_tab_nav">
        <ul class="setting_tab_nav_list">
          <li
            id="t2"
            class="setting_tab_nav_item is_active"
            @click.prevent="changeNavTab(DISPLAY_SETTINGS_TAB)"
          >
            <span class="setting_tab_nav_text">
              {{ dispatchJobSettingProperty.DISPLAY_SETTINGS_TAB_TITLE }}
            </span>
          </li>
          <li
            id="t3"
            class="setting_tab_nav_item"
            @click.prevent="changeNavTab(HEADLINE_TEXT_TAB)"
          >
            <span class="setting_tab_nav_text">
              {{ dispatchJobSettingProperty.HEADLINE_TEXT_TAB_TITLE }}
            </span>
          </li>
          <li
            id="t4"
            class="setting_tab_nav_item"
            @click.prevent="changeNavTab(DETAIL_INFORMATION_TAB)"
          >
            <span class="setting_tab_nav_text">
              {{ dispatchJobSettingProperty.DETAIL_INFORMATION_TAB_TITLE }}
            </span>
          </li>
          <li
            id="t5"
            class="setting_tab_nav_item"
            @click.prevent="changeNavTab(LIST_INFORMATION_TAB)"
          >
            <span class="setting_tab_nav_text">
              {{ dispatchJobSettingProperty.COMPANY_INFORMATION_TAB_TITLE }}
            </span>
          </li>
        </ul>
      </div>
      <div v-show="navTab === DISPLAY_SETTINGS_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <DisplaySettingsTab
            :displaySetting="dispatchJobSearchForm.displaySetting"
            :groupName="groupName"
            :jobCategories="jobCategories"
            :property="property"
            :resourceFields="resourceFields"
            :useType="itemIsUsedInDisplaySetting"
            :userId="log.info.userId"
            @updatedDisplaySetting="updatedDisplaySetting"
            @updatedProperty="updatedProperty"
            @updateResourceField="updateResourceField"
            @getJobResourceFields="getDispatchJobResourceFields(property, $event)"
            @refreshResourceList="refreshResourceList($event)"
            @createLogger="createLogger($event)"
            @sendLogger="sendLogger"
          />
        </div>
      </div>
      <div v-show="navTab === HEADLINE_TEXT_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <HeadlineTextTab
            :bodySettings="bodySettings"
            :headingSettings="headingSettings"
            :groupName="groupName"
            :jobCategories="jobCategories"
            :property="property"
            :resourceFields="resourceFields"
            :useType="itemIsUsedInHeadingBodySetting"
            :userId="log.info.userId"
            @updatedProperty="updatedProperty"
            @updateResourceField="updateResourceField"
            @getJobResourceFields="getDispatchJobResourceFields(property, $event)"
            @refreshResourceList="refreshResourceList($event)"
            @createLogger="createLogger($event)"
            @sendLogger="sendLogger"
            ref="HeadlineTextTabComponent"
          />
        </div>
      </div>
      <div
        v-show="navTab === DETAIL_INFORMATION_TAB"
        class="setting_tab_content"
      >
        <div class="setting_tab_content_panel is_active">
          <DetailInformationTab
            :categories="dispatchJobDetailForm.categorySetting"
            :jobCategories="jobCategories"
            :groupName="groupName"
            :property="property"
            :resourceFields="resourceFields"
            :useType="itemIsUsedInDetailForm"
            :userId="log.info.userId"
            :companyCategories="companyCategories"
            :companyResourceFields="companyResourceFields"
            :propertySearchCompany="propertySearchCompany"
            @updatedProperty="updatedProperty"
            @updateResourceField="updateResourceField"
            @updateCategory="updatedJobDetailCategory"
            @getJobResourceFields="getDispatchJobResourceFields(property, $event)"
            @refreshResourceList="refreshResourceList($event)"
            @createLogger="createLogger($event)"
            @sendLogger="sendLogger"
            @refreshCompanyResourceList="refreshCompanyResourceList($event)"
            @updatedSearchCompanyProperty="updatedSearchCompanyProperty"
            @getCompanyResourceFields="getCompanyResourceFields(propertySearchCompany, $event)"
            @updateScrollMenu="scrollMenuItem"
            @updateEditingStatus="updateEditingStatus"
          />
        </div>
      </div>
      <div
        v-show="navTab === LIST_INFORMATION_TAB"
        class="setting_tab_content"
      >
        <div class="setting_tab_content_panel is_active">
          <ListInformationTab
              :categories="dispatchJobListForm.categorySetting"
              :groupName="groupName"
              :jobCategories="jobCategories"
              :property="property"
              :resourceFields="resourceFields"
              :useType="itemIsUsedInListForm"
              :userId="log.info.userId"
              :companyCategories="companyCategories"
              :companyResourceFields="companyResourceFields"
              :propertySearchJob="propertySearchJob"
              @updatedProperty="updatedProperty"
              @updateResourceField="updateResourceField"
              @updateCategory="updatedJobListCategory"
              @getJobResourceFields="getDispatchJobResourceFields(propertySearchJob, $event)"
              @refreshResourceList="refreshResourceList($event)"
              @createLogger="createLogger($event)"
              @sendLogger="sendLogger"
              @refreshCompanyResourceList="refreshCompanyResourceList($event)"
              @updateCompanyResourceField="updateCompanyResourceField"
              @getCompanyResourceFields="getCompanyResourceFields(property, $event)"
              @updatedSearchJobProperty="updatedSearchJobProperty"
              @updateScrollMenu="scrollMenuItem"
              @updateEditingStatus="updateEditingStatus"
          />
        </div>
      </div>
    </div>
    <div class="setting_footer" id="setting_footer">
      <button
        class="setting_btn_outline"
        @click="cancelChangeJobDataSetting()"
      >
        {{ dispatchJobSettingProperty.CANCEL_BUTTON }}
      </button>
      <button
        class="setting_btn_primary"
        @click="saveData()"
        :class="{
          'setting_btn_disabled': isDisableSaveBtn || editingStatus
        }"
      >
        {{ dispatchJobSettingProperty.SAVE_BUTTON }}
      </button>
      <div class="setting_footer_balloon" v-if="unSavedData">
        {{ dispatchJobSettingNotifyProperty.SAVE_CHANGE_DATA }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import DisplaySettingsTab from "./DispatchJobSettingsComponents/DisplaySettingsTab.vue";
import HeadlineTextTab from "./DispatchJobSettingsComponents/HeadlineTextTab.vue";
import DetailInformationTab from "./DispatchJobSettingsComponents/DetailInformationTab.vue";
import ListInformationTab from "./DispatchJobSettingsComponents/ListInformationTab.vue";
import VueToast from "vue-toast-notification";
import formSettingService from "../../../services/FormSettingService";
import dispatchJobSettingService from "../../../services/DispatchJobSettingService";
import dispatchJobSettingProperty from "../../../properties/dispatch_job_screen/dispatch-job-screen.json";
import dispatchJobSettingNotifyProperty from "../../../properties/dispatch_job_screen/dispatch-job-notifications.json";
import entrySettingNotificationProperty from "../../../properties/entry_screen/notifications.json";
import * as StrUtil from "../../../util/StringUtil";
import * as generalLabels from "../../../properties/general_page/generalpage-labels.json";
import * as generalMessages from "../../../properties/general_page/generalpage.json";
import generalService from "../../../services/GeneralService";
import jobSettingService from "../../../services/JobSettingService";
import Utils from "../../../Utils";
Vue.use(VueToast);

const JOB_SEARCH_FORM_TYPE = 1;
const JOB_DETAIL_FORM_TYPE = 2;
const JOB_LIST_FORM_TYPE = 4;
const DISPATCH_JOB_SEARCH_FORM_TYPE = 5;
const DISPATCH_JOB_DETAIL_FORM_TYPE = 6;
const DISPATCH_JOB_LIST_FORM_TYPE = 7;

const HEADING_SETTING_TYPE = 0;
const BODY_SETTING_TYPE = 1;

const DISPLAY_SETTINGS_TAB = 2;
const HEADLINE_TEXT_TAB = 3;
const DETAIL_INFORMATION_TAB = 4;
const LIST_INFORMATION_TAB = 5;
const START_PAGE_TITLE = generalLabels.START_TITLE_PAGE + " > " + dispatchJobSettingProperty.PAGE_TITLE + " > ";
const RESOURCE_NOT_VIEW_SETTINGS = [ "amount_over_shorts", "is_target_over_age_60_boolean_type_id", "dispatch_job_type_id", "created_user_id", "updated_user_id", "photo", "files" ];

export default {
  name: "DispatchJobScreenSettings",
  props: ["groupName", "unSavedData", "userId", "token"],
  components: {
    DisplaySettingsTab,
    HeadlineTextTab,
    DetailInformationTab,
    ListInformationTab
  },
  data: function () {
    return {
      jobListForm: {
        categorySetting: [],
        buttonSetting: []
      },
      jobDetailForm: {
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      jobSearchForm: {
        displaySetting: {
          displayRecord: 50,
          companyPublicSetting: "",
          homepagePostingSetting: "",
          companyPublicSettings: [],
          homepagePostingSettings: [],
        },
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      dispatchJobDetailForm: {
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      dispatchJobListForm: {
        categorySetting: [],
        buttonSetting: []
      },
      dispatchJobSearchForm: {
        displaySetting: {
          displayRecord: 50,
          companyPublicSetting: "",
          homepagePostingSetting: "",
          companyPublicSettings: [],
          homepagePostingSettings: [],
        },
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      bodySettings: [],
      headingSettings: [],
      searchColors: {
        themeName: "Default",
        borderColor: "#989090",
        keyColor: "#CFC9C9",
        linkText: "#3090D9",
        mainButtonText: "#FFFFFF",
        mainButton: "#F36A07",
        pageBackground: "#FFFFFF",
        pageText: "#0D0D0D",
        subButton: "#F8F7F7",
        subButtonText: "#000000",
        subColor: "#E7E4E4",
      },
      selectedTheme: -1,
      searchCustomizeSettings: [],
      detailCustomizeSettings: [],
      property: "",
      resourceFields: [],
      jobCategories: [],
      propertySearchJob: "",
      propertySearchCompany: "",
      companyResourceFields: [],
      companyCategories: [],
      itemResourcesUsedInDetailForm: [],
      itemResourcesUsedInCompanyForm: [],
      itemResourcesUsedInDisplaySetting: [],
      itemResourcesUsedInHeadLineText: [],
      itemsDeletedMainSystem: [],
      idItemsDeletedMainSystems: [],
      itemIdHeadingBodyDeletedMainSystem: [],
      dispatchJobSettingProperty: dispatchJobSettingProperty,
      dispatchJobSettingNotifyProperty: dispatchJobSettingNotifyProperty,
      navTab: DISPLAY_SETTINGS_TAB,
      itemIsUsedInDisplaySetting: 2,
      itemIsUsedInHeadingBodySetting: 3,
      itemIsUsedInDetailForm: 4,
      itemIsUsedInListForm: 5,
      log: {
        info: {},
      },
      isDisableSaveBtn: false,
      DISPLAY_SETTINGS_TAB: DISPLAY_SETTINGS_TAB,
      HEADLINE_TEXT_TAB: HEADLINE_TEXT_TAB,
      DETAIL_INFORMATION_TAB: DETAIL_INFORMATION_TAB,
      LIST_INFORMATION_TAB: LIST_INFORMATION_TAB,
      isLoadingData: true,
      draftSearchHeadingBodySettings:[],
      draftDetailHeadingBodySettings:[],
      editingStatus: false
    };
  },
  async created() {
    document.title = START_PAGE_TITLE + dispatchJobSettingProperty.SEARCH_ENTRY_TAB_TITLE;
    await this.createLogger("Load data " + generalLabels.SIXTH_TAB);

    await this.getDispatchJobResourceFields("", this.log.hash);
    await this.getDispatchJobCategories(this.log.hash);
    await this.getCompanyResourceFields("", this.log.hash);
    await this.getCompanyCategories(this.log.hash);

    await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, this.log.hash);
    await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, this.log.hash);

    await this.getSearchFormData(JOB_SEARCH_FORM_TYPE, this.log.hash);
    await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
    await this.getListFormData(JOB_LIST_FORM_TYPE, this.log.hash);
    await this.getDispatchJobSearchFormData(DISPATCH_JOB_SEARCH_FORM_TYPE, this.log.hash);
    await this.getDispatchJobDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
    await this.getDispatchJobListFormData(DISPATCH_JOB_LIST_FORM_TYPE, this.log.hash);

    await this.checkItemDeletedFromMainSystem(this.log.hash);

    if (this.itemsDeletedMainSystem.length > 0) {
      alert(
        entrySettingNotificationProperty.NOTIFY_ITEM_DELETED +
          "\n" +
          this.itemsDeletedMainSystem.join("\n")
      );
    }

    if (this.idItemsDeletedMainSystems.length > 0) {
      await formSettingService
        .updateTimeItemDeleted(
          this.idItemsDeletedMainSystems,
          this.log.hash,
          this.token
        )
        .catch((e) => {
          console.log(e);
        });
    }

    if (this.itemIdHeadingBodyDeletedMainSystem.length > 0) {
      await formSettingService
        .updateTimeItemHeadingBodyDeleted(
          this.itemIdHeadingBodyDeletedMainSystem,
          this.log.hash,
          this.token
        )
        .catch((e) => {
          console.log(e);
        });
    }

    this.isLoadingData = false;
    this.editingStatus = false;
  },
  methods: {
    updateResourceField(resources) {
      this.resourceFields = resources;
    },

    async changeNavTab(tab) {
      if (this.navTab === tab) {
        return;
      }

      switch (tab) {
        case DISPLAY_SETTINGS_TAB:
          document.title = START_PAGE_TITLE + dispatchJobSettingProperty.DISPLAY_SETTINGS_TAB_TITLE;
          await this.createLogger(
            "Menu " +
              generalLabels.SIXTH_TAB +
              "-Click tab " +
              dispatchJobSettingProperty.DISPLAY_SETTINGS_TAB_TITLE
          );
          await this.checkItemDeletedFromMainSystem(this.log.hash);
          break;
        case HEADLINE_TEXT_TAB:
          document.title = START_PAGE_TITLE + dispatchJobSettingProperty.HEADLINE_TEXT_TAB_TITLE;
          await this.createLogger(
            "Menu " +
              generalLabels.SIXTH_TAB +
              "-Click tab " +
              dispatchJobSettingProperty.HEADLINE_TEXT_TAB_TITLE
          );
          await this.checkItemDeletedFromMainSystem(this.log.hash);
          this.$refs.HeadlineTextTabComponent.checkCanDragDrop();
          break;
        case DETAIL_INFORMATION_TAB:
          document.title = START_PAGE_TITLE + dispatchJobSettingProperty.DETAIL_INFORMATION_TAB_TITLE;
          await this.createLogger(
            "Menu " +
              generalLabels.SIXTH_TAB +
              "-Click tab " +
              dispatchJobSettingProperty.DETAIL_INFORMATION_TAB_TITLE
          );
          await this.checkItemDeletedFromMainSystem(this.log.hash);
          break;
        case LIST_INFORMATION_TAB:
          document.title = START_PAGE_TITLE + dispatchJobSettingProperty.COMPANY_INFORMATION_TAB_TITLE;
          await this.createLogger(
            "Menu " +
              generalLabels.SIXTH_TAB +
              "-Click tab " +
              dispatchJobSettingProperty.COMPANY_INFORMATION_TAB_TITLE
          );
          await this.checkItemDeletedFromMainSystem(this.log.hash);
          break;
      }

      if(document.getElementById("t" + this.navTab) && document.getElementById("t" + tab)){
        document.getElementById("t" + this.navTab).classList.remove("is_active");
        document.getElementById("t" + tab).classList.add("is_active");
      }
      this.navTab = tab;
    },

    updatedProperty(val) {
      this.property = val;
    },

    updatedSearchCompanyProperty(val) {
      this.propertySearchCompany = val;
    },

    updatedSearchJobProperty(val) {
      this.propertySearchJob = val;
    },

    updatedDisplaySetting(displaySetting) {
      this.dispatchJobSearchForm.displaySetting = displaySetting;
    },

    async getDispatchJobResourceFields(property, hash) {
      property = StrUtil.toHalfWidth(property);
      let searchDto = {};
      searchDto.keyWord = property;
      await dispatchJobSettingService
        .getDispatchJobResourceField(searchDto, hash)
        .then((response) => {
          if (response && response.data != null) {
            this.resourceFields = [];
            Object.keys(response.data).filter(key => !RESOURCE_NOT_VIEW_SETTINGS.includes(key)).map(key => {
              if (response.data[key].property_category_name === undefined) {
                Object.keys(response.data[key]).map(subKey => {
                  let subResource = response.data[key][subKey];
                  subResource.name = key + "." + subResource.name;
                  this.resourceFields.push(subResource);
                });
              } else {
                this.resourceFields.push(response.data[key]);
              }
            });

            this.refreshResourceField();
          }
        })
        .catch((e) => {
          Utils.responsePageMaintenance(e);
          Vue.$toast.clear();
          Vue.$toast.error(dispatchJobSettingNotifyProperty.NOTIFY_ERROR_GET_ITEM_JOB, {
            position: "bottom-right",
            duration: 3000,
          });
        });
    },

    async getDispatchJobCategories(hash) {
      await dispatchJobSettingService
        .getDispatchJobCategories(hash, this.token)
        .then((response) => {
          if (response && response.data != null) {
            this.jobCategories = Object.keys(response.data).map((key) => {
              return response.data[key];
            });
          }
        })
        .catch((e) => {
          Utils.responsePageMaintenance(e);
          Vue.$toast.clear();
          Vue.$toast.error(
            dispatchJobSettingNotifyProperty.NOTIFY_ERROR_GET_JOB_CATEGORY,
            {
              position: "bottom-right",
              duration: 3000,
            }
          );
        });
    },

    async getCompanyResourceFields(property, hash) {
      property = StrUtil.toHalfWidth(property);
      let searchDto = {};
      searchDto.keyWord = property;
      await dispatchJobSettingService
        .getCompanyResourceFields(searchDto, hash)
        .then((response) => {
          if (response && response.data != null) {
            this.companyResourceFields = Object.keys(response.data).filter(key => key && key !== "files" && key !== "photo").map(
              (key) => {
                return response.data[key];
              }
            );
            this.refreshCompanyResourceField();
          }
        })
        .catch((e) => {
          Utils.responsePageMaintenance(e);
          Vue.$toast.clear();
          Vue.$toast.error(dispatchJobSettingNotifyProperty.NOTIFY_ERROR_GET_ITEM_JOB, {
            position: "bottom-right",
            duration: 3000,
          });
        });
    },

    updateCompanyResourceField(companyResourceFields){
      this.companyResourceFields = companyResourceFields;
    },

    async getCompanyCategories(hash) {
      await dispatchJobSettingService
        .getCompanyCategories(hash, this.token)
        .then((response) => {
          if (response && response.data != null) {
            this.companyCategories = Object.keys(response.data).map((key) => {
              return response.data[key];
            });
          }
        })
        .catch((e) => {
          Utils.responsePageMaintenance(e);
          Vue.$toast.clear();
          Vue.$toast.error(
            dispatchJobSettingNotifyProperty.NOTIFY_ERROR_GET_JOB_CATEGORY,
            {
              position: "bottom-right",
              duration: 3000,
            }
          );
        });
    },

    refreshCompanyResourceField() {
      this.modifyCompanyItemResource();
      this.hideCompanyResourceItemWasUsed(this.itemResourcesUsedInDetailForm, this.itemIsUsedInDetailForm);
      this.hideCompanyResourceItemWasUsed(this.itemResourcesUsedInListForm, this.itemIsUsedInListForm);
      this.companyResourceFields = JSON.parse(JSON.stringify(this.companyResourceFields));
    },

    modifyCompanyItemResource() {
      this.companyResourceFields.filter(resource => resource && resource.name).forEach(resource => {
        resource.isUsed = !resource.isUsed ? [] : resource.isUsed;
        resource.name = resource.name.startsWith(dispatchJobSettingProperty.ITEM_COMPANY_MODIFY) ? resource.name : dispatchJobSettingProperty.ITEM_COMPANY_MODIFY + resource.name;
      });
    },

    hideCompanyResourceItemWasUsed(dataSettings, itemUsedType) {
      if (!dataSettings || dataSettings.length <= 0) {
        return;
      }

      dataSettings.forEach(itemResourcesUsed => {
        this.companyResourceFields.filter(companyResource => companyResource.name === itemResourcesUsed.name).forEach(companyResource => {
          if (!companyResource.isUsed.includes(itemUsedType)) {
            companyResource.isUsed.push(itemUsedType);
          }
        });
      });
    },

    refreshResourceField() {
      this.getItemResourcesUsed();
      this.modifyJobItemResource();
      this.refreshResourceInDataSetting(
        this.itemResourcesUsedInDetailForm,
        this.itemIsUsedInDetailForm
      );
      this.refreshResourceInDataSetting(this.itemResourcesUsedInListForm, this.itemIsUsedInListForm);
      this.refreshResourceInDataSetting(
        this.itemResourcesUsedInHeadLineText,
        this.itemIsUsedInHeadingBodySetting
      );
      this.refreshResourceInDataSetting(
        this.itemResourcesUsedInDisplaySetting,
        this.itemIsUsedInDisplaySetting
      );
      this.resourceFields = JSON.parse(JSON.stringify(this.resourceFields));
    },

    modifyJobItemResource() {
      this.resourceFields.forEach((resource) => {
        if (!resource.isUsed) {
          resource.isUsed = [];
        }
      });
    },

    refreshResourceInDataSetting(dataSettings, itemUsedType) {
      if (dataSettings.length <= 0) {
        return;
      }

      dataSettings.forEach((itemMasterUsed) => {
        this.resourceFields
          .filter((itemMaster) => itemMasterUsed.name === itemMaster.name)
          .forEach((itemMaster) => {
            if (!itemMaster.isUsed.includes(itemUsedType)) {
              itemMaster.isUsed.push(itemUsedType);
            }
          });
      });
    },

    getItemResourcesUsed() {
      this.getItemWasUsedInFormSetting(
        this.dispatchJobDetailForm,
        DISPATCH_JOB_DETAIL_FORM_TYPE
      );
      this.getItemWasUsedInFormSetting(this.dispatchJobListForm, DISPATCH_JOB_LIST_FORM_TYPE);

      this.getItemUsingInSettings(
        this.itemResourcesUsedInHeadLineText,
        this.headingSettings
      );
      this.getItemUsingInSettings(
        this.itemResourcesUsedInHeadLineText,
        this.bodySettings
      );
      this.getItemUsingInDisplaySettingTab(this.dispatchJobSearchForm.displaySetting);
    },

    getItemWasUsedInFormSetting(formData, type) {
      if (type === DISPATCH_JOB_DETAIL_FORM_TYPE) {
        this.itemResourcesUsedInDetailForm = [];
      } else {
        this.itemResourcesUsedInListForm = [];
      }

      if (!formData || formData.categorySetting.length <= 0) {
        return;
      }

      let itemResourcesUsedForm = type === DISPATCH_JOB_DETAIL_FORM_TYPE ? this.itemResourcesUsedInDetailForm : this.itemResourcesUsedInListForm;
      formData.categorySetting.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category => {
        category.item.filter(item => !item.itemDeleted && item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter(resource => resource && resource.name).forEach(resource => {
            if (resource.itemResourceDeleted) {
              this.removeResourceWasUsed(itemResourcesUsedForm, resource);
              return;
            }

            let resourceUsed = itemResourcesUsedForm.some(itemResourceUsed => itemResourceUsed.name === resource.name);
            if (!resourceUsed) {
              itemResourcesUsedForm.push(resource);
            }
          });
        });
      });

      formData.categorySetting.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0 && item.itemDeleted).forEach(item => {
          item.resourceField.filter(resource => resource && resource.name).forEach(resource => this.removeResourceWasUsed(itemResourcesUsedForm, resource));
        });
      });

      formData.categorySetting.filter(category => category.item && category.item.length > 0 && category.categoryDeleted).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter(resource => resource && resource.name).forEach(resource => this.removeResourceWasUsed(itemResourcesUsedForm, resource));
        });
      });
    },

    addResourceWasUsed(resourcesUsedInFormSetting, resource) {
      if (
        resourcesUsedInFormSetting.some(
          (itemResourceUsed) => itemResourceUsed.name === resource.name
        ) ||
        resource.itemResourceDeleted
      ) {
        return;
      }

      resourcesUsedInFormSetting.push(resource);
    },

    removeResourceWasUsed(resourcesUsedInFormSetting, resource) {
      if (
        !resourcesUsedInFormSetting.some(
          (itemResourceUsed) => itemResourceUsed.name === resource.name
        )
      ) {
        return;
      }
      let indexOfResourceWasUsed = resourcesUsedInFormSetting.findIndex(
        (item) => item.name === resource.name
      );
      resourcesUsedInFormSetting.splice(indexOfResourceWasUsed, 1);
    },

    getItemUsingInSettings(itemResourcesUsed, dataSettings) {
      if (!dataSettings || dataSettings.length <= 0) {
        return;
      }

      dataSettings.forEach((itemSettings) => {
        if (itemSettings.itemResourceDeleted) {
          this.removeResourceWasUsed(itemResourcesUsed, itemSettings);
        } else {
          this.addResourceWasUsed(itemResourcesUsed, itemSettings);
        }
      });
    },

    getItemUsingInDisplaySettingTab(setting) {
      this.itemResourcesUsedInDisplaySetting = [];
      if (
        setting.companyPublicSettings &&
        setting.companyPublicSettings.length > 0
      ) {
        setting.companyPublicSettings.forEach((companyPublicSetting) => {
          if (companyPublicSetting.itemResourceDeleted) {
            let indexResourceDeleted =
              this.itemResourcesUsedInDisplaySetting.findIndex(
                (item) => item.name === companyPublicSetting.name
              );
            if (indexResourceDeleted >= 0) {
              this.itemResourcesUsedInDisplaySetting.splice(
                indexResourceDeleted,
                1
              );
            }
          }

          if (
            !this.itemResourcesUsedInDisplaySetting.some(
              (itemResourceUsed) =>
                itemResourceUsed.name === companyPublicSetting.name
            ) &&
            !companyPublicSetting.itemResourceDeleted
          ) {
            this.itemResourcesUsedInDisplaySetting.push(companyPublicSetting);
          }
        });
      }

      if (setting.homepagePostingSettings && setting.homepagePostingSettings.length > 0) {
        setting.homepagePostingSettings.forEach((homepagePostingSetting) => {
          if (homepagePostingSetting.itemResourceDeleted) {
            let indexResourceDeleted =
              this.itemResourcesUsedInDisplaySetting.findIndex(
                (item) => item.name === homepagePostingSetting.name
              );
            if (indexResourceDeleted >= 0) {
              this.itemResourcesUsedInDisplaySetting.splice(
                indexResourceDeleted,
                1
              );
            }
          }

          if (
            !this.itemResourcesUsedInDisplaySetting.some(
              (itemResourceUsed) =>
                itemResourceUsed.name === homepagePostingSetting.name
            ) &&
            !homepagePostingSetting.itemResourceDeleted
          ) {
            this.itemResourcesUsedInDisplaySetting.push(homepagePostingSetting);
          }
        });
      }
    },
    async getSearchFormData(type, hash) {
      await formSettingService
          .getFormSettingByType(type, hash)
          .then( async (response) => {
            if (!response || !response.data || !response.data.id) {
              return;
            }

            this.jobSearchForm = response.data;
            this.handleInputColor();
          })
          .catch((e) => {
            console.log(e);
          });
    },

    async getDispatchJobSearchFormData(type, hash) {
      await formSettingService
        .getFormSettingByType(type, hash)
        .then( async (response) => {
          if (!response || !response.data || !response.data.id) {
            return;
          }

          this.dispatchJobSearchForm = response.data;
          this.handleInputBodySetting();

          this.property = "";
          await this.getDispatchJobResourceFields("", hash);
          await this.handleInputDisplaySetting();
          this.refreshResourceField();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getDetailFormData(type, hash) {
      await formSettingService
        .getFormSettingByType(type, hash)
        .then((response) => {
          if (!response || !response.data || !response.data.id) {
            return;
          }

          this.jobDetailForm = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getDispatchJobDetailFormData(type, hash) {
      await formSettingService
        .getFormSettingByType(type, hash)
        .then((response) => {
          if (!response || !response.data || !response.data.id) {
            return;
          }

          this.dispatchJobDetailForm = response.data;
          this.handleCategorySetting(type);
          this.refreshResourceField();
          this.refreshCompanyResourceField();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getListFormData(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.jobListForm = response.data;
      }).catch(e => {
        console.log(e);
      });
    },

    async getDispatchJobListFormData(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.dispatchJobListForm = response.data;
        this.handleCategorySetting(type);
        this.refreshResourceField();
        this.refreshCompanyResourceField();
      }).catch(e => {
        console.log(e);
      });
    },

    handleCategorySetting(type) {
      switch (type) {
        case DISPATCH_JOB_DETAIL_FORM_TYPE:
          this.dispatchJobDetailForm.categorySetting.forEach(category => category.isCollapse = false);
          break;
        case DISPATCH_JOB_LIST_FORM_TYPE:
          this.dispatchJobListForm.categorySetting.forEach(category => category.isCollapse = false);
          break;
      }
    },

    async handleInputDisplaySetting() {
      let companyName = this.dispatchJobSearchForm.displaySetting.companyPublicSetting;
      if (!companyName) {
        this.dispatchJobSearchForm.displaySetting.companyPublicSettings = [];
      } else {
        let itemCompany = this.resourceFields.find( (resource) => resource.name === companyName);
        if (!this.dispatchJobSearchForm.displaySetting.companyPublicSettings) {
          this.dispatchJobSearchForm.displaySetting.companyPublicSettings = [];
        }

        if (itemCompany) {
          this.dispatchJobSearchForm.displaySetting.companyPublicSettings.push(itemCompany);
        }
      }

      let homepageName = this.dispatchJobSearchForm.displaySetting.homepagePostingSetting;
      if (!homepageName) {
        this.dispatchJobSearchForm.displaySetting.homepagePostingSettings = [];
      } else {
        let itemHomepage = this.resourceFields.find((resource) => resource.name === homepageName);
        if (!this.dispatchJobSearchForm.displaySetting.homepagePostingSettings) {
          this.dispatchJobSearchForm.displaySetting.homepagePostingSettings = [];
        }

        if (itemHomepage) {
          this.dispatchJobSearchForm.displaySetting.homepagePostingSettings.push(itemHomepage);
        }
      }
    },

    handleInputBodySetting() {
      this.headingSettings = [];
      this.bodySettings = [];
      this.dispatchJobSearchForm.bodyHeadingSetting.forEach((setting) => {
        switch (setting.type) {
          case HEADING_SETTING_TYPE: {
            this.headingSettings.push(setting);
            break;
          }
          case BODY_SETTING_TYPE: {
            this.bodySettings.push(setting);
            break;
          }
        }
      });
    },

    handleOutputBodyHeadingSetting(settings, type) {
      let bodyHeadingSearchSettings = [];
      settings.forEach((setting) => {
        if (setting.id) {
          const index = this.dispatchJobSearchForm.bodyHeadingSetting.findIndex((item) => item.id === setting.id);
          bodyHeadingSearchSettings.push({
            id: this.dispatchJobSearchForm.bodyHeadingSetting[index].id,
            name: setting.name,
            display_name: setting.display_name,
            itemResourceDeleted: setting.itemResourceDeleted,
            type: type,
            isDeletedByMainSystem: setting.isDeletedByMainSystem
          });
        } else {
          bodyHeadingSearchSettings.push({
            name: setting.name,
            display_name: setting.display_name,
            itemResourceDeleted: setting.itemResourceDeleted,
            isDeletedByMainSystem: setting.isDeletedByMainSystem,
            type: type,
          });
        }
      });
      bodyHeadingSearchSettings.forEach(setting => {
        this.draftSearchHeadingBodySettings.push(setting);
      })
    },

    formatBodyHeadingSettingDetailForm() {
      this.draftSearchHeadingBodySettings.forEach(item => {
        if (!item.itemResourceDeleted) {
          let cloneItem = JSON.parse(JSON.stringify(item));
          if (cloneItem.id && this.dispatchJobDetailForm.bodyHeadingSetting.find(i => i.name === cloneItem.name)) {
            cloneItem.id = this.dispatchJobDetailForm.bodyHeadingSetting.find(i => i.name === cloneItem.name).id;
          } else {
            delete cloneItem.id;
          }

          this.draftDetailHeadingBodySettings.push(cloneItem);
        }
      })
    },

    handleInputColor() {
      this.selectedTheme = this.jobSearchForm.formColorTheme;
      const index = this.searchCustomizeSettings.findIndex(item => item.id === this.selectedTheme);
      if (index === -1) {
        this.selectedTheme = this.searchCustomizeSettings[0].id;
        this.searchColors.themeName = this.searchCustomizeSettings[0].themeName;
        this.searchColors.borderColor = this.searchCustomizeSettings[0].borderColor;
        this.searchColors.keyColor = this.searchCustomizeSettings[0].keyColor;
        this.searchColors.linkText = this.searchCustomizeSettings[0].linkText;
        this.searchColors.mainButtonText = this.searchCustomizeSettings[0].mainButtonText;
        this.searchColors.mainButton = this.searchCustomizeSettings[0].mainButton;
        this.searchColors.pageBackground = this.searchCustomizeSettings[0].pageBackground;
        this.searchColors.pageText = this.searchCustomizeSettings[0].pageText;
        this.searchColors.subButton = this.searchCustomizeSettings[0].subButton;
        this.searchColors.subButtonText = this.searchCustomizeSettings[0].subButtonText;
        this.searchColors.subColor = this.searchCustomizeSettings[0].subColor;
      } else {
        this.searchColors.themeName = this.searchCustomizeSettings[index].themeName;
        this.searchColors.borderColor = this.searchCustomizeSettings[index].borderColor;
        this.searchColors.keyColor = this.searchCustomizeSettings[index].keyColor;
        this.searchColors.linkText = this.searchCustomizeSettings[index].linkText;
        this.searchColors.mainButtonText = this.searchCustomizeSettings[index].mainButtonText;
        this.searchColors.mainButton = this.searchCustomizeSettings[index].mainButton;
        this.searchColors.pageBackground = this.searchCustomizeSettings[index].pageBackground;
        this.searchColors.pageText = this.searchCustomizeSettings[index].pageText;
        this.searchColors.subButton = this.searchCustomizeSettings[index].subButton;
        this.searchColors.subButtonText = this.searchCustomizeSettings[index].subButtonText;
        this.searchColors.subColor = this.searchCustomizeSettings[index].subColor;
      }
    },

    handleOutputData() {
      this.draftSearchHeadingBodySettings = [];
      this.draftDetailHeadingBodySettings = [];

      Promise.all([this.handleOutputBodyHeadingSetting(this.headingSettings, HEADING_SETTING_TYPE), this.handleOutputBodyHeadingSetting(this.bodySettings, BODY_SETTING_TYPE)]).then(() => {
        this.formatBodyHeadingSettingDetailForm();
        this.dispatchJobSearchForm.bodyHeadingSetting = this.draftSearchHeadingBodySettings;
        this.dispatchJobDetailForm.bodyHeadingSetting = this.draftDetailHeadingBodySettings;
      })

      this.handleOutputColors();
      this.handleOutputDisplaySetting(this.dispatchJobSearchForm.displaySetting);
      this.handleOutPutItemSetting(this.dispatchJobDetailForm);
      this.handleOutPutItemSetting(this.dispatchJobListForm);
    },

    handleOutputColors() {
      if (this.selectedTheme === -1) {
        this.jobSearchForm.customizeSetting = this.searchColors;
        this.jobDetailForm.customizeSetting = this.searchColors;
      } else {
        const index = this.searchCustomizeSettings.findIndex(item => item.id === this.selectedTheme);
        if (index === -1) {
          this.jobSearchForm.customizeSetting = this.searchColors;
          this.jobDetailForm.customizeSetting = this.searchColors;
        } else {
          this.jobSearchForm.customizeSetting = this.searchCustomizeSettings[index];
          this.jobDetailForm.customizeSetting = this.detailCustomizeSettings[index];
        }
      }
    },

    handleOutPutItemSetting(formData){
      if (!formData.categorySetting || formData.categorySetting.length <= 0) {
        return;
      }

      formData.categorySetting.filter(category => category && category.item && category.item.length > 0).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter(resource => resource).forEach(resource => {
            delete resource.default_value;
            if (resource.display_name && resource.display_name.length > 255) {
              resource.display_name = resource.display_name.substring(0, 255);
            }
          });
        });
      })
    },

    handleOutputDisplaySetting(displaySetting) {
      let companySettings = displaySetting.companyPublicSettings;
      if (companySettings && companySettings.length > 0) {
        let hasItemCompanySetting = companySettings.find((companyPublicSetting) => companyPublicSetting && !companyPublicSetting.itemResourceDeleted);
        if (hasItemCompanySetting) {
          this.dispatchJobSearchForm.displaySetting.companyPublicSetting = hasItemCompanySetting.name;
        } else {
          this.dispatchJobSearchForm.displaySetting.companyPublicSetting = "";
        }
      }

      let homepageSettings = displaySetting.homepagePostingSettings;
      if(homepageSettings && homepageSettings.length > 0){
        let hasItemHomePageSetting = homepageSettings.find((homepagePostingSetting) => homepagePostingSetting && !homepagePostingSetting.itemResourceDeleted);
        if (hasItemHomePageSetting) {
          this.dispatchJobSearchForm.displaySetting.homepagePostingSetting = hasItemHomePageSetting.name;
        } else {
          this.dispatchJobSearchForm.displaySetting.homepagePostingSetting = "";
        }
      }
    },

    async saveData() {
      this.isLoadingData = true;
      Vue.$toast.clear();
      this.handleOutputData();
      this.log.info.paras = {
        dispatchJobSearchForm: this.dispatchJobSearchForm,
        dispatchJobDetailForm: this.dispatchJobDetailForm,
        dispatchJobListForm: this.dispatchJobListForm,
      };
      await this.createLogger(
          "Menu " +
          generalLabels.SIXTH_TAB +
          "-Click button " +
          dispatchJobSettingProperty.SAVE_BUTTON
      );
      Promise.all([
        formSettingService.saveJobSearchForm(this.jobSearchForm, this.log.hash, this.token),
        formSettingService.saveJobDetailForm(this.jobDetailForm, this.log.hash, this.token),
        formSettingService.saveJobListForm(this.jobListForm, this.log.hash, this.token),
        dispatchJobSettingService.saveDispatchJobSearchForm(
          this.dispatchJobSearchForm,
          this.log.hash,
          this.token
        ),
        dispatchJobSettingService.saveDispatchJobDetailForm(
          this.dispatchJobDetailForm,
          this.log.hash,
          this.token
        ),
        dispatchJobSettingService.saveDispatchJobListForm(
          this.dispatchJobListForm,
          this.log.hash,
          this.token
        ),
      ])
        .then(async () => {
          Vue.$toast.success(
            entrySettingNotificationProperty.SAVE_SUCCESSFUL,
            {
              position: "bottom-right",
              duration: 3000,
            }
          );

          await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, this.log.hash);
          await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, this.log.hash);
          await this.getSearchFormData(JOB_SEARCH_FORM_TYPE, this.log.hash);
          await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
          await this.getListFormData(JOB_LIST_FORM_TYPE, this.log.hash);
          await this.getDispatchJobSearchFormData(DISPATCH_JOB_SEARCH_FORM_TYPE, this.log.hash);
          await this.getDispatchJobDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
          await this.getDispatchJobListFormData(DISPATCH_JOB_LIST_FORM_TYPE, this.log.hash);
          this.$eventBus.$emit("unSaved", false);
        })
        .catch((e) => {
          console.log(e);
          if (e.response.data === 'Form has been already updated!') {
            Vue.$toast.error(generalMessages.ERROR_FORM_HAS_BEEN_UPDATED, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          } else {
            Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          }
        }).finally(() => {
          this.isLoadingData = false;
        });

      delete this.log.info.paras;
    },

    async cancelChangeJobDataSetting() {
      this.isLoadingData = true;
      await this.createLogger(
        "Menu " +
          generalLabels.SIXTH_TAB +
          "-Click button " +
          dispatchJobSettingProperty.CANCEL_BUTTON
      );
      await this.getSearchFormData(JOB_SEARCH_FORM_TYPE, this.log.hash);
      await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
      await this.getListFormData(JOB_LIST_FORM_TYPE, this.log.hash);
      await this.getDispatchJobSearchFormData(DISPATCH_JOB_SEARCH_FORM_TYPE, this.log.hash);
      await this.getDispatchJobDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
      await this.getDispatchJobListFormData(DISPATCH_JOB_LIST_FORM_TYPE, this.log.hash);
      await this.checkItemDeletedFromMainSystem(this.log.hash);

      if (this.itemsDeletedMainSystem.length > 0) {
        alert(
          entrySettingNotificationProperty.NOTIFY_ITEM_DELETED +
            "\n" +
            this.itemsDeletedMainSystem.join("\n")
        );
      }

      await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, this.log.hash);
      await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, this.log.hash);
      if(!this.dispatchJobSearchForm.id || !this.dispatchJobDetailForm.id || !this.dispatchJobListForm.id){
        this.resetDataSetting();
      }
      this.$eventBus.$emit("unSaved", false);
      this.isLoadingData = false;
    },

    resetDataSetting(){
      this.dispatchJobSearchForm = {
        displaySetting: {
          displayRecord: 50,
          companyPublicSetting: "",
          homepagePostingSetting: "",
          companyPublicSettings: [],
          homepagePostingSettings: [],
        },
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      }
      this.dispatchJobListForm = {
        categorySetting: [],
        buttonSetting: []
      }
      this.dispatchJobDetailForm = {
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      }

      this.jobListForm = {
        categorySetting: [],
        buttonSetting: []
      };
      this.jobDetailForm = {
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      };
      this.jobSearchForm = {
        displaySetting: {
          displayRecord: 50,
          companyPublicSetting: "",
          homepagePostingSetting: "",
          companyPublicSettings: [],
          homepagePostingSettings: [],
        },
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      };
      this.bodySettings = [];
      this.headingSettings = [];
      this.selectedTheme = 1;
    },

    async getJobSearchCustomizes(type, hash) {
      await jobSettingService.getCustomizeTheme(type, hash, this.token).then(response => {
        this.searchCustomizeSettings = response.data;
        if (this.searchCustomizeSettings.length !== 0 && this.selectedTheme === -1) {
          this.selectedTheme = this.searchCustomizeSettings[0].id;
        }
      }).catch(e => {
        console.log(e);
      });
    },

    async getJobDetailCustomizes(type, hash) {
      await jobSettingService.getCustomizeTheme(type, hash, this.token).then(response => {
        this.detailCustomizeSettings = response.data;
      }).catch(e => {
        console.log(e);
      });
    },

    updatedJobDetailCategory() {
      this.dispatchJobDetailForm = JSON.parse(JSON.stringify(this.dispatchJobDetailForm));
    },

    updatedJobListCategory() {
      this.dispatchJobListForm = JSON.parse(JSON.stringify(this.dispatchJobListForm));
    },

    async checkItemDeletedFromMainSystem(hash) {
      await this.getDispatchJobResourceFields("", hash);
      await this.getCompanyResourceFields("", hash);
      let isNullJobResourceField = !this.resourceFields || this.resourceFields.length <= 0;
      let isNullCompanyResourceField = !this.companyResourceFields || this.companyResourceFields.length <= 0;
      if (isNullJobResourceField || isNullCompanyResourceField) {
        return;
      }
      await this.checkItemDeletedInDataFormSetting(
        this.dispatchJobSearchForm,
        DISPATCH_JOB_SEARCH_FORM_TYPE
      );
      await this.checkItemDeletedInDataFormSetting(
        this.dispatchJobDetailForm,
        DISPATCH_JOB_DETAIL_FORM_TYPE
      );
      await this.checkItemDeletedInDataFormSetting(
        this.dispatchJobListForm,
        DISPATCH_JOB_LIST_FORM_TYPE
      );
    },

    async checkItemDeletedInDataFormSetting(formData, formType) {
      await this.checkItemDeletedInDisplaySettingHeadingBody(formData.bodyHeadingSetting);
      if (formType === DISPATCH_JOB_SEARCH_FORM_TYPE) {
        await this.checkItemDeletedInDisplaySetting(formData.displaySetting.companyPublicSettings);
        await this.checkItemDeletedInDisplaySetting(formData.displaySetting.homepagePostingSettings);
      }

      if (!formData.categorySetting || formData.categorySetting.length <= 0) {
        return;
      }

      if (formType !== DISPATCH_JOB_SEARCH_FORM_TYPE) {
        formData.categorySetting.forEach(category => {
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
            item.resourceField.forEach(resourceUsed => {
              this.checkItemResourceHasDeleted(resourceUsed, item);
            });
          });
        });
      }
    },

    checkItemResourceHasDeleted(resourceUsed, item) {
      let resourceFields = resourceUsed.name.startsWith(dispatchJobSettingProperty.ITEM_COMPANY_MODIFY) ? this.companyResourceFields : this.resourceFields;
      if (resourceFields.findIndex(resourceMain => resourceMain.name === resourceUsed.name) < 0) {
        item.isDeletedByMainSystem = true;
        resourceUsed.isItemDeletedByMainSystem = true;
        if (!this.itemsDeletedMainSystem.includes(resourceUsed.display_name)) {
          this.itemsDeletedMainSystem.push(resourceUsed.display_name);
        }

        this.idItemsDeletedMainSystems.push(resourceUsed.id);
      }
    },

    async checkItemDeletedInDisplaySettingHeadingBody(dataSettings) {
      if (!dataSettings || dataSettings.length <= 0) {
        return;
      }

      dataSettings.forEach((itemSettings) => {
        if (this.resourceFields.findIndex((resourceMain) => resourceMain.name === itemSettings.name) < 0) {
          itemSettings.isItemDeletedByMainSystem = true;
          itemSettings.isDeletedByMainSystem = true;
          this.itemIdHeadingBodyDeletedMainSystem.push(itemSettings.id);
          if (!this.itemsDeletedMainSystem.includes(itemSettings.display_name)) {
            this.itemsDeletedMainSystem.push(itemSettings.display_name);
          }
        }
      });

      if (this.bodySettings.length > 0) {
        this.bodySettings.forEach(bodySetting => {
          let existData = dataSettings.findIndex(data => bodySetting.name === data.name && data.type === 1);
          if (existData === -1) {
            bodySetting.isItemDeletedByMainSystem = true;
            bodySetting.isDeletedByMainSystem = true;
          }
        })
      }

      if (this.headingSettings.length > 0) {
        this.headingSettings.forEach(headingSetting => {
          let existData = dataSettings.findIndex(data => headingSetting.name === data.name && data.type === 0);
          if (existData === -1) {
            headingSetting.isItemDeletedByMainSystem = true;
            headingSetting.isDeletedByMainSystem = true;
          }
        })
      }
    },

    async checkItemDeletedInDisplaySetting(dataSettings) {
      if (!dataSettings || dataSettings.length <= 0) {
        return;
      }

      dataSettings.forEach(itemSettings => {
        if (this.resourceFields.findIndex(resourceMain => resourceMain.name === itemSettings.name) < 0) {
          itemSettings.isItemDeletedByMainSystem = true;
          itemSettings.isDeletedByMainSystem = true;
          this.itemIdHeadingBodyDeletedMainSystem.push(itemSettings.id);
          if (!this.itemsDeletedMainSystem.includes(itemSettings.display_name)) {
            this.itemsDeletedMainSystem.push(itemSettings.display_name);
          }
        }
      });
    },

    async refreshResourceList(hash) {
      this.isLoadingData = true;
      await dispatchJobSettingService
        .deleteRedisData(hash, this.token)
        .then(() => {
          Promise.all([this.getDispatchJobResourceFields("", hash), this.getDispatchJobCategories(hash)]).finally(() => {
            this.isLoadingData = false;
          })
        })
        .catch((e) => {
          console.log(e);
          Vue.$toast.clear();
          Vue.$toast.error(
              entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE,
              {
                position: "bottom-right",
                duration: 3000,
              }
          );
        });
    },
    async refreshCompanyResourceList(hash) {
      this.isLoadingData = true;
      await dispatchJobSettingService
        .resetDataCompanyInRedis(hash, this.token)
        .then(() => {
          Promise.all([this.getCompanyResourceFields("", hash), this.getCompanyCategories(hash)]).finally(() => {
            this.isLoadingData = false;
          })
        })
        .catch((e) => {
          console.log(e);
          Vue.$toast.clear();
          Vue.$toast.error(
              entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE,
              {
                position: "bottom-right",
                duration: 3000,
              }
          );
        });
    },

    scrollMenuItem() {
      let scroll = document.getElementById("dispatch-job-main-content");
      let startPublicSettingScroll = document.getElementById(
        "menu-search-item-setting-dispatch-job-public-settings"
      );
      let startHeadLineText = document.getElementById(
        "menu-search-item-head-line-text"
      );
      let elementFixMenuDetail = document.getElementById(
        "menu-search-item-dispatch-job-tab-detail"
      );
      let elementFixMenuList = document.getElementById(
        "menu-search-item-dispatch-job-tab-list"
      );

      if (
        !startPublicSettingScroll ||
        !scroll ||
        !startHeadLineText ||
        !elementFixMenuDetail ||
        !elementFixMenuList
      ) {
        return;
      }
      let heightOfTop = window.innerHeight;
      if (scroll.scrollTop > 105) {
        heightOfTop = heightOfTop - 24;
        startPublicSettingScroll.style.top = scroll.scrollTop - 105 + "px";
        startHeadLineText.style.top = scroll.scrollTop - 105 + "px";
        elementFixMenuDetail.style.top = scroll.scrollTop - 105 + "px";
        elementFixMenuList.style.top = scroll.scrollTop - 105 + "px";
      } else {
        startPublicSettingScroll.style.top = "0px";
        startHeadLineText.style.top = "0px";
        elementFixMenuDetail.style.top = "0px";
        elementFixMenuList.style.top = "0px";
      }
      this.resizeHeightMenuSearch(heightOfTop);
      if (this.navTab === DETAIL_INFORMATION_TAB) {
        this.resizeTwoHeightMenuSearch(DETAIL_INFORMATION_TAB, heightOfTop);
      }

      if (this.navTab === LIST_INFORMATION_TAB) {
        this.resizeTwoHeightMenuSearch(LIST_INFORMATION_TAB, heightOfTop);
      }
    },

    resizeHeightMenuSearch(heightOfTop){
      let windowInnerHeight = heightOfTop;
      let elementHeadingSearchByTab = document.getElementById("dispatch_job_heading_search_item_" + this.navTab);
      if(!elementHeadingSearchByTab){
        return;
      }
      let elementHeadingSearch = elementHeadingSearchByTab.getBoundingClientRect();
      let elementFooter = document.getElementById("setting_footer").getBoundingClientRect();
      let elementResetHeight = document.getElementById("item_resource_wrapper_" + this.navTab);
      if(!elementHeadingSearch || !elementFooter || !elementResetHeight){
        return;
      }
      elementResetHeight.style.height = (windowInnerHeight - (elementHeadingSearch.y + elementHeadingSearch.height + elementFooter.height)) +"px";
    },

    resizeTwoHeightMenuSearch(tab, heightOfTop) {
      let elementJobHeadingSearch = document.getElementById("dispatch_job_heading_search_item_" + tab);
      let elementCompanyHeadingSearch = document.getElementById("dispatch_company_heading_search_item_" + tab);
      if (!elementJobHeadingSearch || !elementCompanyHeadingSearch) {
        return;
      }

      let elementFooter = document.getElementById("setting_footer").getBoundingClientRect();
      let elementHideItemJob = document.getElementById("dispatch_job_item_resource_wrap_" + tab);
      let elementHideItemCompany = document.getElementById("dispatch_company_item_resource_wrap_" + tab);
      if (!elementHideItemJob || !elementHideItemCompany || !elementFooter) {
        return;
      }

      let isDisplayJob = elementHideItemJob.style.display;
      let isDisplayCompany = elementHideItemCompany.style.display;
      let boundJobHeadingSearch = elementJobHeadingSearch.getBoundingClientRect();
      let boundCompanyHeadingSearch = elementCompanyHeadingSearch.getBoundingClientRect();
      let companyHeight = boundCompanyHeadingSearch.height;
      let jobHeight = boundJobHeadingSearch.height;
      let heightFinal = heightOfTop - (boundJobHeadingSearch.y + boundJobHeadingSearch.height + elementFooter.height);
      if (isDisplayJob === 'block' && isDisplayCompany === "block") {
        heightFinal = (heightFinal + jobHeight) / 2;
      }

      elementHideItemJob.setAttribute("style", "display: " + isDisplayJob + ";height: " + (heightFinal - companyHeight) + "px !important");
      elementHideItemCompany.setAttribute("style", "display: " + isDisplayCompany + ";height: " + (heightFinal - jobHeight) + "px !important");
    },

    async sendLogger(loggerData) {
      this.logs = loggerData;
      await generalService
        .sendLogger(this.logs.hash, this.logs.info.path, this.logs)
        .then((response) => {
          if (response.status === 200) {
            return true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async createLogger(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.sendLogger(this.log);
    },

    updateEditingStatus(status) {
      this.editingStatus = status;
    }
  },
};
</script>

<style lang="css" scoped>
.setting_heading {
  height: 29px;
}
</style>
